import type { ApprovalTask } from '../types';
import { api } from './apiClient';

export type ApprovalDecision = 'approve' | 'reject';

export const approvalsService = {
  async list(): Promise<ApprovalTask[]> {
    const res = await api.get<{ tasks: ApprovalTask[] }>('/approvals');
    return res.tasks;
  },

  // Tarefas pendentes em que a pessoa é aprovadora.
  async listForUser(userId?: string): Promise<ApprovalTask[]> {
    const query = userId ? `?userId=${encodeURIComponent(userId)}` : '';
    const res = await api.get<{ tasks: ApprovalTask[] }>(
      `/approvals${query}`,
    );
    return res.tasks;
  },

  async pendingCountForUser(userId?: string): Promise<number> {
    const query = userId ? `?userId=${encodeURIComponent(userId)}` : '';
    const res = await api.get<{ count: number }>(
      `/approvals/pending-count${query}`,
    );
    return res.count;
  },

  async decide(
    taskId: string,
    decision: ApprovalDecision,
    editedOutput?: string,
  ): Promise<ApprovalTask> {
    const res = await api.post<{ task: ApprovalTask }>(
      `/approvals/${encodeURIComponent(taskId)}/decide`,
      { decision, editedOutput },
    );
    return res.task;
  },

  // Cria uma tarefa (usado quando um run pausa em human_review).
  async create(task: ApprovalTask): Promise<ApprovalTask> {
    const res = await api.post<{ task: ApprovalTask }>('/approvals', task);
    return res.task;
  },
};
